import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';

function FirstStepForgotPassword() {
	const [email, setEmail] = useState("")
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

	const sendForgotPasswordMail = (e) => {

		e.preventDefault();
		var object = {};
		object.email = email;

		var exp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		if (object.email == "") {
			swal("Warning!", "Please provide a email", "warning");
			return false;
		}
		else if (!object.email.match(exp)) {
			swal("Warning!", "Please provide a valid email", "warning");
			return false;
		}

		setMainSubmitButtonState(true);
		axios.post(`${process.env.REACT_APP_SERVER_URL}/send-forgot-password-mail`, object).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data.operation == "success") {
				swal("", "If this email is registered, a password reset link has been sent to it.\n Please check your mail.", "success").then((res) => {
					window.location.reload();
				});
			}
			else {
				if (res.data.message != "danger") {
					swal("Oops!", res.data.message, "error").then((res) => {
						window.location.reload();
					});
				}
				else {
					swal("Oops!", "This email is not registered us", "error").then((res) => {
						window.location.reload();
					});
				}
			}
		})
			.catch(function (error) {
				swal("Oops!", "something went wrong", "error").then((res) => {
					window.location.reload();
				});
			});
	}

	return (
		<>
			<div
				className="app-blank bgi-size-cover bgi-attachment-fixed bgi-position-center bgi-no-repeat"
				style={{
					backgroundSize: "cover",
					backgroundImage: "url(assets/media/auth/bg4.jpg)",
				}}
			>
				<div className="d-flex flex-column flex-root min-vh-100">
					<div className="d-flex flex-column flex-lg-row flex-grow-1">

						{/* LEFT SIDE (Logo + Tagline) */}
						<div className="d-none d-lg-flex flex-center w-lg-50 p-5">
							<div className="d-flex flex-column align-items-center">
								<img
									alt="Logo"
									src={`${process.env.REACT_APP_LOGO}`}
									className="mb-4"
									style={{ maxWidth: "200px" }}
								/>
								<h2 className="text-white text-center fw-normal m-0 fs-3">
									Ultimate Business Management Solution!
								</h2>
							</div>
						</div>

						{/* RIGHT SIDE (Form) */}
						<div className="flex-grow-1 d-flex justify-content-center align-items-center p-4 p-lg-10">
							<div className="bg-body rounded-4 w-100 w-md-600px p-6 p-md-10">
								<form className="form w-100">
									<div className="text-center mb-6">
										<h1 className="text-gray-900 fw-bolder mb-2 fs-3 fs-md-1">
											Forgot Password?
										</h1>
										<div className="text-gray-500 fw-semibold fs-7 fs-md-6">
											Enter your email to reset your password.
										</div>
									</div>

									<div className="fv-row mb-6">
										<input
											type="text"
											placeholder="Email"
											name="email"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											autoComplete="off"
											className="form-control bg-transparent"
										/>
									</div>

									<div className="d-flex flex-wrap justify-content-center">
										<button
											type="button"
											data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
											disabled={mainSubmitButtonState}
											onClick={(e) => sendForgotPasswordMail(e)}
											className="btn btn-primary me-3 mb-2"
										>
											<span className="indicator-label">Submit</span>
											<span className="indicator-progress">
												Please wait...
												<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
											</span>
										</button>
										<button
											type="button"
											onClick={() => window.location.href = "/login"}  // or use navigate("/login") if using react-router
											className="btn btn-light mb-2"
										>
											Back to Sign In
										</button>
									</div>
								</form>

								<div className="d-flex justify-content-center gap-3 mt-4 small">
									<a href="https://www.spoterp.com/terms.html" target="_blank">Terms</a>
									<a href="https://www.spoterp.com/faq.html" target="_blank">FAQs</a>
									<a href="https://www.spoterp.com/erp-software-features.html" target="_blank">Features</a>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</>

	);
}
export default FirstStepForgotPassword;